import { render, staticRenderFns } from "./QuestionsRightSidebar.vue?vue&type=template&id=c805f616&scoped=true&"
import script from "./QuestionsRightSidebar.vue?vue&type=script&lang=js&"
export * from "./QuestionsRightSidebar.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsRightSidebar.vue?vue&type=style&index=0&id=c805f616&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c805f616",
  null
  
)

export default component.exports